import Trailer from './Trailer';

export default Trailer;
